// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk/order-tracker/lazy/" + ({"305":"order-list-new","633":"order-details","640":"ot-unified-track-view","819":"orders-summary"}[chunkId] || chunkId) + "-" + {"305":"c5fe94","326":"ef7e22","633":"6e2764","640":"d27d37","819":"981efb"}[chunkId] + ".css";
};